import Cards from "../../components/cards";
import Navbar from "../../components/navbar";
import { iProduto } from "../../interfaces";
import { produtos } from "../../utils/index";

const Casa = () => {
  return (
    <>
      <div className="wh-100">
        <Navbar />
        <div className="center">
          <Cards produtos={produtos as iProduto[]} />
        </div>
        <footer>
          ©Todos os direitos reservados. | CNPJ: 50.133.965/0001-20 - Extensão
          da Digital While.
        </footer>
      </div>
    </>
  );
};

export default Casa;
